module.exports = __webpack_public_path__ + "img/green-2-diamond-open.1b8e0af3.svg";